/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import {withRouter} from "../Routing/withRouter";

class ForgotPassword extends Component {
    static displayName = ForgotPassword.name;

    render() {
       return (
            <ForgotPasswordForm passwordEmailSent={this.props.passwordEmailSent} endForgotPassword={this.props.endForgotPassword} isMobile={this.props.isMobile} />
       );
    }
}

export default withRouter(ForgotPassword);
